import { render, staticRenderFns } from "./StudipTreeList.vue?vue&type=template&id=1110493c&scoped=true&"
import script from "./StudipTreeList.vue?vue&type=script&lang=js&"
export * from "./StudipTreeList.vue?vue&type=script&lang=js&"
import style0 from "./StudipTreeList.vue?vue&type=style&index=0&id=1110493c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1110493c",
  null
  
)

export default component.exports